import React, { createContext, useContext, useState } from "react";

type ChatInput = {
    input: string;
    metadata?: Record<string, any>;
}

type ChatInputContextType = {
  chatInput: ChatInput
  setChatInput: (value: ChatInput) => void;
};

const ChatInputContext = createContext<ChatInputContextType | undefined>(undefined);

export const useChatInput = () => {
  const ctx = useContext(ChatInputContext);
  if (!ctx) throw new Error("useChatInput must be used within ChatInputProvider");
  return ctx;
};

export const ChatInputProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [chatInput, setChatInput] = useState<ChatInput>({ input: "" });
  return (
    <ChatInputContext.Provider value={{ chatInput, setChatInput }}>
      {children}
    </ChatInputContext.Provider>
  );
};

